import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

// 布局组件
import Layout from '@/views/layout/Index.vue'
import Login from '@/views/login/Index.vue'
import Register from '@/views/login/Register.vue'
import Home from '@/views/home/Home.vue'


//全新机批发
const Brandnew = ()=>import('@/views/brandnew/Index.vue')
const BrandnewModel = ()=>import('@/views/brandnew/list/Model.vue')
const BrandnewSort = ()=>import('@/views/brandnew/list/Sort.vue')
const BrandnewOrder = ()=>import('@/views/brandnew/list/Order.vue')

// 电池批发
const Battery = ()=>import('@/views/battery/Index.vue')
const BatteryModel = ()=>import('@/views/battery/list/Index.vue')
const BatterySort = ()=>import('@/views/battery/sort/Index.vue')
const BatteryOrder = ()=>import('@/views/battery/order/Index.vue')

// 物料管理
const Material = ()=>import('@/views/material/Index.vue')
const MaterialMemory = ()=>import('@/views/material/memory/Index.vue')
const MaterialColor = ()=>import('@/views/material/color/Index.vue')

//快递管理
const Express = ()=>import('@/views/express/Index.vue')
const ExpressList = ()=>import('@/views/express/list/Index.vue')

//设置
const Setting = ()=>import('@/views/Setting.vue')

const routes = [ 
    {
        path: '/',
        component: Layout,
        meta:{
            title:'首页',
            isLogin:true
        },
        children:[
            {
                path:'/',
                name:'home',
                component:Home
            },{
                path:'/brandnew',
                name:'brandnew',
                component:Brandnew,
                children:[
                    {
                        path:'brandnewModel',
                        name:'brandnewModel',
                        component:BrandnewModel
                    },{
                        path:'brandnewSort',
                        name:'brandnewSort',
                        component:BrandnewSort
                    },{
                        path:'brandnewOrder',
                        name:'brandnewOrder',
                        component:BrandnewOrder
                    },
                ]
            },{
                path:'/battery',
                name:'battery',
                component:Battery,
                children:[
                    {
                        path:'batteryModel',
                        name:'batteryModel',
                        component:BatteryModel
                    },{
                        path:'batterySort',
                        name:'batterySort',
                        component:BatterySort
                    },{
                        path:'batteryOrder',
                        name:'batteryOrder',
                        component:BatteryOrder
                    }
                ]
            },{
                path:'/material',
                name:'material',
                component:Material,
                children:[
                    {
                        path:'materialMemory',
                        name:'materialMemory',
                        component:MaterialMemory
                    },{
                        path:'materialColor',
                        name:'materialColor',
                        component:MaterialColor
                    }
                ]
            },{
                path:'/express',
                name:'express',
                component:Express,
                children:[
                    {
                        path:'expressList',
                        name:'expressList',
                        component:ExpressList
                    }
                ]
            },{
                path:'setting',
                name:'setting',
                component:Setting
            }
        ]
    }, {
        path: '/login',
        name: 'login',
        component: Login,
    },{
        path: '/register',
        name: 'register',
        component: Register,
    }
]

const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    // history: createWebHashHistory(process.env.BASE_URL),//修改后
    routes
})

// 配置路由前置守卫
import store from '@/store'
router.beforeEach((to,from,next)=>{
    //判断当前路由是否要登录
    if(to.matched.some(record => record.meta.isLogin)){
        if(store.state.login.userinfo.token){
            next()
        }else{
             next('login')
        }
    }else{
        next()
    }
})


export default router